// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SortableTableLayout_table__kQfZr {
    width: 100%;
}

.SortableTableLayout_header__4kgMD {
    line-height: 30px;
}

.SortableTableLayout_headerItem__eMfU1 {
    font-weight: 400;
    text-align: left;
    user-select: none;
}

.SortableTableLayout_headerItemSortable__Tq-By {
    cursor: pointer;
    white-space: nowrap;
}

.SortableTableLayout_iconContainer__o29-\\+ {
    padding-left: 5px;
    width: 10px;
    height: 10px;
    font-size: 10px;
    display: inline-block;
}

.SortableTableLayout_tableRow__iHLrR {
    border-bottom: 1px solid var(--color-107);
    line-height: 30px;
}

.SortableTableLayout_tableRow__iHLrR:first-child {
    border-bottom: 1px solid var(--color-107);
    border-top: 1px solid var(--color-107);
}

.SortableTableLayout_tableRowItem__s1mBa {
    padding: 5px;
}

.SortableTableLayout_tableRowItem__s1mBa.SortableTableLayout_rightAlign__OGicQ {
    text-align: right;
}

.SortableTableLayout_tableRowItem__s1mBa.SortableTableLayout_leftAlign__6qzao {
    text-align: left;
}

.SortableTableLayout_tableRowItem__s1mBa.SortableTableLayout_centerAlign__5a9Jk {
    text-align: center;
}

/* Alternating Color */
.SortableTableLayout_tableBodyAlternating__gV0\\+l {
    border-left: 1px solid var(--color-107);
    border-right: 1px solid var(--color-107);
}

.SortableTableLayout_noSideBorders__GhFyS {
    border-left: none;
    border-right: none;
}

.SortableTableLayout_tableRowAlternating__P\\+Qrg:nth-child(odd) {
    background-color: var(--color-105);
}

/* Large rows */
.SortableTableLayout_largeRows__OE9Co th, .SortableTableLayout_largeRows__OE9Co td{
    padding: 8px;
}

.SortableTableLayout_footer__xAqy4 {
    padding: 5px;
    white-space: nowrap;
    font-weight: 600;
}

.SortableTableLayout_tableRowItem__s1mBa.SortableTableLayout_selected__XiWPb {
    background: var(--color-412);
}

/* Reflowed table on small screens */
@media (max-width: 47.9375em) {
    .SortableTableLayout_responsive__RU6Iu, 
    .SortableTableLayout_responsive__RU6Iu thead, 
    .SortableTableLayout_responsive__RU6Iu tbody,
    .SortableTableLayout_responsive__RU6Iu th,
    .SortableTableLayout_responsive__RU6Iu tr,
    .SortableTableLayout_responsive__RU6Iu td {
        display: block;
    }

    /* Hiding table headers (but not display: none for accessibility purposes)*/
    .SortableTableLayout_responsive__RU6Iu thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }

    .SortableTableLayout_responsive__RU6Iu tr:first-child {
        border-top: none;
    }

    /* Forcing td to behave like a row.*/
    .SortableTableLayout_responsive__RU6Iu td {
        border: none;
        border-bottom: 1px solid var(--color-107);
        position: relative;
        padding-left: 50%;
        min-height: 30px;
    }

    /*Forcing content "before" to behave like a table heading.*/
    .SortableTableLayout_responsive__RU6Iu td:before {
        content: attr(data-title);

        position: absolute;
        font-weight: bold;
        /* Top/left values mimic padding */
        top: 6px;
        left: 6px;
        width: 45%;
        padding-right: 10px;
        white-space: nowrap;
    }

    .SortableTableLayout_responsive__RU6Iu td:before {
        /*Handling truncation of before content.*/
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .SortableTableLayout_responsive__RU6Iu td:last-child {
        border-bottom-color: var(--color-102);
    }
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/SortableTableLayout/SortableTableLayout.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA,eAAe;AACf;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,oCAAoC;AACpC;IACI;;;;;;QAMI,cAAc;IAClB;;IAEA,2EAA2E;IAC3E;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA,oCAAoC;IACpC;QACI,YAAY;QACZ,yCAAyC;QACzC,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA,2DAA2D;IAC3D;QACI,yBAAyB;;QAEzB,kBAAkB;QAClB,iBAAiB;QACjB,kCAAkC;QAClC,QAAQ;QACR,SAAS;QACT,UAAU;QACV,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,yCAAyC;QACzC,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".table {\n    width: 100%;\n}\n\n.header {\n    line-height: 30px;\n}\n\n.headerItem {\n    font-weight: 400;\n    text-align: left;\n    user-select: none;\n}\n\n.headerItemSortable {\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.iconContainer {\n    padding-left: 5px;\n    width: 10px;\n    height: 10px;\n    font-size: 10px;\n    display: inline-block;\n}\n\n.tableRow {\n    border-bottom: 1px solid var(--color-107);\n    line-height: 30px;\n}\n\n.tableRow:first-child {\n    border-bottom: 1px solid var(--color-107);\n    border-top: 1px solid var(--color-107);\n}\n\n.tableRowItem {\n    padding: 5px;\n}\n\n.tableRowItem.rightAlign {\n    text-align: right;\n}\n\n.tableRowItem.leftAlign {\n    text-align: left;\n}\n\n.tableRowItem.centerAlign {\n    text-align: center;\n}\n\n/* Alternating Color */\n.tableBodyAlternating {\n    border-left: 1px solid var(--color-107);\n    border-right: 1px solid var(--color-107);\n}\n\n.noSideBorders {\n    border-left: none;\n    border-right: none;\n}\n\n.tableRowAlternating:nth-child(odd) {\n    background-color: var(--color-105);\n}\n\n/* Large rows */\n.largeRows th, .largeRows td{\n    padding: 8px;\n}\n\n.footer {\n    padding: 5px;\n    white-space: nowrap;\n    font-weight: 600;\n}\n\n.tableRowItem.selected {\n    background: var(--color-412);\n}\n\n/* Reflowed table on small screens */\n@media (max-width: 47.9375em) {\n    .responsive, \n    .responsive thead, \n    .responsive tbody,\n    .responsive th,\n    .responsive tr,\n    .responsive td {\n        display: block;\n    }\n\n    /* Hiding table headers (but not display: none for accessibility purposes)*/\n    .responsive thead tr {\n        position: absolute;\n        top: -9999px;\n        left: -9999px;\n    }\n\n    .responsive tr:first-child {\n        border-top: none;\n    }\n\n    /* Forcing td to behave like a row.*/\n    .responsive td {\n        border: none;\n        border-bottom: 1px solid var(--color-107);\n        position: relative;\n        padding-left: 50%;\n        min-height: 30px;\n    }\n\n    /*Forcing content \"before\" to behave like a table heading.*/\n    .responsive td:before {\n        content: attr(data-title);\n\n        position: absolute;\n        font-weight: bold;\n        /* Top/left values mimic padding */\n        top: 6px;\n        left: 6px;\n        width: 45%;\n        padding-right: 10px;\n        white-space: nowrap;\n    }\n\n    .responsive td:before {\n        /*Handling truncation of before content.*/\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    .responsive td:last-child {\n        border-bottom-color: var(--color-102);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `SortableTableLayout_table__kQfZr`,
	"header": `SortableTableLayout_header__4kgMD`,
	"headerItem": `SortableTableLayout_headerItem__eMfU1`,
	"headerItemSortable": `SortableTableLayout_headerItemSortable__Tq-By`,
	"iconContainer": `SortableTableLayout_iconContainer__o29-+`,
	"tableRow": `SortableTableLayout_tableRow__iHLrR`,
	"tableRowItem": `SortableTableLayout_tableRowItem__s1mBa`,
	"rightAlign": `SortableTableLayout_rightAlign__OGicQ`,
	"leftAlign": `SortableTableLayout_leftAlign__6qzao`,
	"centerAlign": `SortableTableLayout_centerAlign__5a9Jk`,
	"tableBodyAlternating": `SortableTableLayout_tableBodyAlternating__gV0+l`,
	"noSideBorders": `SortableTableLayout_noSideBorders__GhFyS`,
	"tableRowAlternating": `SortableTableLayout_tableRowAlternating__P+Qrg`,
	"largeRows": `SortableTableLayout_largeRows__OE9Co`,
	"footer": `SortableTableLayout_footer__xAqy4`,
	"selected": `SortableTableLayout_selected__XiWPb`,
	"responsive": `SortableTableLayout_responsive__RU6Iu`
};
export default ___CSS_LOADER_EXPORT___;
